import { makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";
import localForage from "localforage";
import { UserInfo } from "../Models/UserInfo";
import { SavedAttributes } from "../Models/SavedAttributes";

export class DataStore {
  private _serverUrl: string | null = null;
  private _dbKey: string | null = null;
  private _userInfo: UserInfo | null = null;
  //private _userPermissions: UserPermissions | null = null;
  private _attributes: SavedAttributes = {
    attrs: {},
  };
  private _permittedServers: string[] | null = null;
  private _licenseValidatedServerUrl: string | null = null;
  //warehouse location chosen at login, null when the user has no PDAWarehouseLocations
  private _location: number | null = null;

  constructor() {
    localForage.config({
      name: "pda-picking-rego",
      version: 1.0,
      driver: localForage.LOCALSTORAGE,
    });
    makeAutoObservable(this);
    makePersistable(this, {
      name: "pda-picking-rego-store",
      properties: ["_serverUrl", "_dbKey", "_userInfo", "_attributes", "_permittedServers", "_location"] as (keyof this)[],
      //expireIn: 86400000, // One day in milliseconds
      //removeOnExpiration: true,
      storage: localForage,
      stringify: false,
    });
  }
  public clear(): void {
    //localForage.clear();
    this.serverUrl = null;
    this.dbKey = null;
    this.userInfo = null;
    this.attributes = {
      attrs: {},
    };
    this.permittedServers = null;
    this.location = null;
  }
  public get serverUrl(): string | null {
    return this._serverUrl;
  }

  public set serverUrl(value: string | null) {
    this._serverUrl = value;
  }

  public get dbKey(): string | null {
    return this._dbKey;
  }

  public set dbKey(value: string | null) {
    this._dbKey = value;
  }

  public get userInfo(): UserInfo | null {
    return this._userInfo;
  }

  public set userInfo(value: UserInfo | null) {
    this._userInfo = value;
  }

  public get attributes(): SavedAttributes {
    return this._attributes;
  }

  public set attributes(value: SavedAttributes) {
    this._attributes = value;
  }

  public get licenseValidatedServerUrl(): string | null {
    return this._licenseValidatedServerUrl;
  }

  public set licenseValidatedServerUrl(value: string | null) {
    this._licenseValidatedServerUrl = value;
  }

  public get permittedServers(): string[] | null {
    return this._permittedServers;
  }

  public set permittedServers(value: string[] | null) {
    this._permittedServers = value;
  }

  public get location(): number | null {
    return this._location;
  }

  public set location(value: number | null) {
    this._location = value;
  }
}

const dataStore = new DataStore();
export default dataStore;
